import React from 'react';
import { Button, Col, Container, Div, Image, Row, Text } from '@pinpoint/design-kit';

// import CONSTANTS from 'src/store/constants';

function Login({
  location: { search },
  match: {
    params: { cognitoClientId },
  },
}) {
  const redirectUri = `${window.location.origin}/token/${cognitoClientId}`;
  const encodedRedirectUri = encodeURIComponent(redirectUri);
  const authInitUrl = `${process.env.REACT_APP_COGNITO_DOMAIN}/authorize?client_id=${cognitoClientId}&response_type=code&scope=email+openid+phone+profile&redirect_uri=${encodedRedirectUri}`;

  return (
    <Div
      minW="100vw"
      w="100%"
      minH="100vh"
      h="100%"
      d="flex"
      justify="center"
      align="center"
      p={{ x: '1rem', y: '4rem' }}
      pos="relative"
    >
      <Image
        src="/static/login-back.png"
        srcSet="/static/login-back@2x.png 2x,/static/login-back@3x.png 3x,"
        alt="background"
        w="100vw"
        h="100vh"
        pos="absolute"
        top="0"
        style={{
          objectFit: 'cover',
        }}
      />
      <Div
        w="420px"
        d="flex"
        flexDirection="column"
        align="center"
        shadow="5"
        p={{ x: '2rem', t: '3rem', b: '1rem' }}
        rounded="sm"
        bg="black75"
        zIndex="10"
        style={{
          backdropFilter: 'blur(8px)',
        }}
      >
        <Container>
          <Div d="flex" justify="center" align="center">
            <Image src="/static/on-point-login.svg" w="108px" h="78px" />
          </Div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <Row m={{ t: '1rem', b: '1rem' }}>
              <Col size={{ xs: '12' }}>
                <Div d="flex" justify="center">
                  <Button
                    bg="teal"
                    hoverBg="blueLight"
                    textColor="black"
                    p={{ y: '1em', x: '1.5em' }}
                    textSize="subtitle"
                    onClick={() => {
                      window.location.href = authInitUrl;
                    }}
                  >
                    Sign in with SSO
                  </Button>
                </Div>
              </Col>
            </Row>
          </form>
          <Div d="flex" justify="space-between" align="center">
            <Div p={{ y: '1rem' }} d="flex" justify="center">
              <Image w="90px" h="2rem" src="/static/powered-by-pinpoint-white.svg" />
            </Div>
            <Div h="1.5rem" border={{ r: '1px solid' }} borderColor="gray400" />
            <Div p={{ y: '1rem' }} d="flex" justify="center">
              <Text
                textDecor="underline"
                textSize="caption"
                textColor="gray400"
                cursor="pointer"
                onClick={() => {
                  window.open('https://pinpointpredictive.com/tos/', '_blank') ||
                    window.location.replace('https://pinpointpredictive.com/tos/');
                }}
              >
                Terms of Service
              </Text>
            </Div>
          </Div>
        </Container>
      </Div>
    </Div>
  );
}

Login.propTypes = {};

export default Login;
